'use client';

import React from 'react';
import type { ListState, Node } from 'react-stately';
import { ToggleCheckbox } from 'components/Toggle';
import styles from './Carousel.module.css';
import { useCarouselItemCheckbox } from './useCarouselItemCheckbox';

type CarouselCheckboxProps<T> = {
  item: Node<T>;
  state: ListState<T>;
};

export function CarouselItemCheckbox<T>({
  item,
  state,
}: CarouselCheckboxProps<T>) {
  const { isFocusVisible, isSelected, isDisabled, isPressed, checkboxProps } =
    useCarouselItemCheckbox(state, item);

  return (
    <div className={styles.checkboxPosition}>
      <ToggleCheckbox
        aria-label={'Select item'}
        // @ts-expect-error FIXME(strictNullChecks)
        checked={isSelected}
        data-focus-visible={isFocusVisible || undefined}
        data-pressed={isPressed}
        disabled={isDisabled}
        // @ts-expect-error FIXME(strictNullChecks)
        tabIndex={0}
        {...checkboxProps}
        variant="over-image"
      />
    </div>
  );
}
